import produce from "immer";
import { createAsyncAction } from "typesafe-actions";
import { ActionType, createReducer } from "typesafe-actions";
import { Comment, ViewServiceRequestData, } from "../../../Types/UnitFeatureTypes";


export interface FetchServiceRequestUpdatesInfoState {
  request: {
      loading: boolean;
      error: string | null;
      data: Comment[] | null;
  };
}

export enum Types {
  FETCH_SERVICE_REQUEST_UPDATES_REQUEST = "FETCH_SERVICE_REQUEST_UPDATES_REQUEST",
  FETCH_SERVICE_REQUEST_UPDATES_SUCCESS = "FETCH_SERVICE_REQUEST_UPDATES_SUCCESS",
  FETCH_SERVICE_REQUEST_UPDATES_FAILURE = "FETCH_SERVICE_REQUEST_UPDATES_FAILURE",
}

const serviceRequestUpdatesActions = createAsyncAction(
  Types.FETCH_SERVICE_REQUEST_UPDATES_REQUEST,
  Types.FETCH_SERVICE_REQUEST_UPDATES_SUCCESS,
  Types.FETCH_SERVICE_REQUEST_UPDATES_FAILURE,
)
<
  { service_request_id: number },
  { serviceRequestUpdates: Comment[] },
  { message: string }
>();

export const Actions = { serviceRequestUpdatesActions };

export const initialState: FetchServiceRequestUpdatesInfoState = {
  request: {
    loading: false,
    error: null as string | null,
    data: null,
  }
};

export type FetchServiceRequestUpdatesState = typeof initialState;

const fetchServiceRequestUpdatesRequest = (state = initialState) =>
  produce(state, (draft) => {
    draft.request.loading = true;
    draft.request.error = null;
    draft.request.data = null;

    return draft;
  });

const fetchServiceRequestUpdatesSuccess = (
  state = initialState,
  { payload }: ActionType<typeof Actions.serviceRequestUpdatesActions.success>
) =>
  produce(state, (draft) => {
    draft.request.error = null;
    draft.request.data = payload.serviceRequestUpdates;
    if (draft.request.data) {
      draft.request.loading = false;
    }

    return draft;
  });

const fetchServiceRequestUpdatesFailure = (
  state = initialState,
  { payload }: ActionType<typeof Actions.serviceRequestUpdatesActions.failure>
) =>
  produce(state, (draft) => {
    draft.request.loading = false;
    draft.request.error = payload.message;

    return draft;
  });


export default createReducer<typeof initialState, ActionType<typeof Actions>>(
  initialState
)
  .handleAction(Actions.serviceRequestUpdatesActions.request, fetchServiceRequestUpdatesRequest)
  .handleAction(Actions.serviceRequestUpdatesActions.success, fetchServiceRequestUpdatesSuccess)
  .handleAction(Actions.serviceRequestUpdatesActions.failure, fetchServiceRequestUpdatesFailure);
  